import { render, staticRenderFns } from "./EditorialPage.vue?vue&type=template&id=fd19e576"
import script from "./EditorialPage.js?vue&type=script&lang=js&external"
export * from "./EditorialPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports